import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f7d50d6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "logo" }),
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, " Kim, Hwan ")
], -1))
const _hoisted_3 = { class: "menu-container" }
const _hoisted_4 = { class: "themes" }
const _hoisted_5 = ["checked"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "switch",
  for: "theme-button"
}, null, -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" OpenSource Projects ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Server Info ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" About ")
const _hoisted_10 = { class: "icon-menus" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 🚀 ")
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 🖥 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 👨‍💻 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, { to: "/" }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("input", {
          id: "theme-button",
          type: "checkbox",
          checked: _ctx.isDarkTheme,
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleTheme && _ctx.toggleTheme(...args)))
        }, null, 40, _hoisted_5),
        _hoisted_6
      ]),
      _createVNode(_component_router_link, { to: "/opensource-projects" }, {
        default: _withCtx(() => [
          _hoisted_7
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/server-info" }, {
        default: _withCtx(() => [
          _hoisted_8
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, { to: "/about" }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, { to: "/opensource-projects" }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/server-info" }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        })
      ])
    ])
  ]))
}